import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Col, Container, Form, FormFeedback, Input, Row, Label, Modal } from 'reactstrap'
import { useFormik } from "formik";
import * as Yup from "yup";
import 'flatpickr/dist/themes/material_green.css';
import Select from 'react-select';
import { isEmpty } from 'lodash';
import { addQueryRemarks, getQueryInfomation, updateProductQueryStatus } from 'helpers/UAM/inquiry.helper';
import moment from 'moment';
import ToastDialog from 'common/ToastDialog';
import ConfirmationModal from 'components/Common/ConfirmationModal';
import { SystemConfigurationContext } from 'context/systemConfigContext';
import "../../assets/scss/custom/pages/_inquiry.scss"

const ProductDescription = ({ desc = "" }) => {
    document.title = 'Edit Query | DMS'
    let descLength = desc.length

    const [showReadMore, setShowReadMore] = useState(descLength > 150);

    let descToShow = desc.substring(0, 150);
    let descToHide = desc.substring(150, descLength);

    const handleReadMore = () => {
        setShowReadMore(false);
    }

    const handleReadLess = () => {
        setShowReadMore(true);
    }

    return (
        <p>
            {showReadMore ? descToShow : descToShow + descToHide} {" "}
            {showReadMore && (
                <span style={{ cursor: 'pointer' }} className="read-more-link  text-decoration-underline" onClick={handleReadMore}>
                    ...Read More
                </span>
            )}
            {descLength > 150 && (!showReadMore) && (
                <span style={{ cursor: 'pointer' }} className="read-more-link  text-decoration-underline" onClick={handleReadLess}>
                    Read Less
                </span>
            )}
        </p>
    )
}

const PreviewFile = ({ file }) => {

    const previewUrl = `${process.env.REACT_APP_IMAGE_URL}/${file}`

    const handleFilePreview = (url) => {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = url.split('/').pop();
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                setToastInfo({ message: error.message, showToast: true, role: "error" });
            });
    }


    return (
        <div className="d-flex align-items-center">
            {file ? (
                <p className="text-success text-xl" onClick={() => handleFilePreview(previewUrl)} style={{
                    cursor: "pointer",
                }}>
                    <i color='#21a946' className="bx bx-download"></i>
                </p>
            ) : (
                <span className="preview-message">-</span>
            )}
        </div>
    );
}

const EditQuery = () => {
    const navigate = useNavigate()
    let { id } = useParams();
    if (!isEmpty(id)) {
        id = atob(id)
    }
    const [isBtnLoading, setIsBtnLoading] = useState(false)
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [inquiryInfo, setInquiryInfo] = useState({});
    const [confirmationStatus, setConfirmationStatus] = useState(null);
    const { inputMax } = useContext(SystemConfigurationContext)

    const statusOptions = [
        { value: 'resolve', label: 'Closed (Resolve)' },
        { value: 'lost', label: 'Closed (Lost)' },
    ]

    const handleFormSubmit = async (values) => {
        setIsBtnLoading(true)
        const bodyData = {
            id: inquiryInfo.id,
            remarks: values.remarks,
        }
        const res = await addQueryRemarks(bodyData);
        if (res.status) {
            formik.resetForm()
            getInquiryInfo()
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
        setIsBtnLoading(false)
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            remarks: '',
        },
        validationSchema: Yup.object({
            remarks: Yup.string().required('Remarks is required'),
        }),
        onSubmit: async (values) => {
            handleFormSubmit(values)
        },
    });

    const setInquiryData = (data) => {
        let file = !isEmpty(data.file) ? JSON.parse(data.file) : []
        file = !isEmpty(file) ? file : ''
        const inquiryData = {
            id: data.id,
            queryStatus: data.queryStatus,
            description: data.description,
            dealerName: data.dealer.entityName,
            file: file,
            remarks: data.remarks,
        }
        setInquiryInfo(inquiryData)
    }

    async function getInquiryInfo() {
        const res = await getQueryInfomation({ id: id })

        if (res.status) {
            setInquiryData(res.data)
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
    }

    useEffect(() => {
        getInquiryInfo()
    }, [id])

    const handleStatus = (option) => {
        setConfirmationStatus(option.value)
    }

    const handleStatusChange = async (status) => {
        const bodyData = {
            id,
            queryStatus: status
        }
        const res = await updateProductQueryStatus(bodyData);
        if (res.status) {
            setToastInfo({ message: res.message, showToast: true, role: "success" });
            getInquiryInfo()
            setConfirmationStatus(null)
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="page-title-box pb-2 d-flex gap-3 justify-content-between align-items-center mb-1 w-100">
                        <h4 className='mb-0'>Edit Query</h4>
                        <div>
                            <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={() => navigate(-1)}
                            >
                                Back
                            </button>
                        </div>

                    </div>

                    <Row className='g-2'>
                        <Col sm={12} md={12} lg={12} xl={12} className='card'>
                            <div className='card-body p-4'>
                                <Row>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Dealer Name</Label>
                                        <p className="">{inquiryInfo.dealerName}</p>
                                    </div>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Download attachment</Label>
                                        <PreviewFile file={inquiryInfo.file} />
                                    </div>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Status</Label>
                                        <Select
                                            options={statusOptions}
                                            className='select2-container select2-container--default'
                                            classNamePrefix="select2-selection"
                                            value={statusOptions.find(obj => obj.value === inquiryInfo.queryStatus)}
                                            isDisabled={inquiryInfo.queryStatus == 'resolve' || inquiryInfo.queryStatus == 'lost'}
                                            onChange={(e) => {
                                                handleStatus(e)
                                            }}
                                        />
                                    </div>
                                    <div className="col-6 mb-3">
                                        <Label className="form-label">Query</Label>
                                        <ProductDescription desc={inquiryInfo.description} />
                                    </div>
                                </Row>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6} xl={6} className=' card'>
                            <Row className="timeline card-body pb-0">
                                {inquiryInfo.queryStatus == 'open' && <Form className='px-1 mt-2' onSubmit={formik.handleSubmit}>
                                    <div style={{ width: '100%', position: 'relative' }}>
                                        <div style={{ marginBottom: '20px' }}>
                                            <Input
                                                maxLength={inputMax}
                                                value={formik.values.remarks}
                                                type='textarea'
                                                name='remarks'
                                                id='remarks'
                                                placeholder='Enter your query/comments'
                                                onChange={formik.handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    resize: 'none',
                                                    width: '100%',
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                }}
                                                className={`${formik.touched.remarks && formik.errors.remarks ? 'is-invalid' : ''}`}
                                            />
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '8px', right: '10px' }}>
                                            <Button
                                                disabled={isBtnLoading}
                                                type='submit'
                                                color='success'
                                                style={{ padding: '8px', borderRadius: '50%', width: '40px', height: '40px' }}
                                            >
                                                {isBtnLoading && <span className='spinner-border spinner-border-sm mr-1'></span>}
                                                <i className='bx bx-send'></i>
                                            </Button>

                                        </div>
                                        {formik.touched.remarks && formik.errors.remarks ? (
                                            <FormFeedback className='d-block text-danger' style={{ position: 'absolute', bottom: '-20px', left: '10px' }}>
                                                {formik.errors.remarks}
                                            </FormFeedback>
                                        ) : null}
                                    </div>

                                </Form>}
                                <div style={{
                                    height: inquiryInfo.queryStatus == 'open' ? '450px' : 'auto',
                                    overflowY: 'scroll',
                                }}>
                                    {!isEmpty(inquiryInfo?.remarks) ? inquiryInfo?.remarks.slice(0).reverse().map((item, index) => {
                                        return (
                                            <div className="msger-chat" key={index}>
                                                {item.addedBy !== 'user' ?
                                                    <div className="msg left-msg">
                                                        <div className="msg-bubble">
                                                            <div className="msg-info">
                                                                <div className="msg-info-name">{item.user}</div>
                                                                <div className="msg-info-time"><span>{moment(item.createdAt).format("MMM DD YYYY, HH:mm A")}</span></div>
                                                            </div>
                                                            <div className="msg-text">
                                                                {item.remarks}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="msg right-msg">


                                                        <div className="msg-bubble">
                                                            <div className="msg-info">
                                                                <div className="msg-info-name">{item.user}</div>
                                                                <div className="msg-info-time d-flex flex-column">
                                                                    <span>{moment(item.createdAt).format("MMM DD YYYY, HH:mm A")}</span></div>
                                                            </div>

                                                            <div className="msg-text">
                                                                {item.remarks}
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                        )
                                    }) :
                                        (
                                            <div className='d-flex align-items-center justify-content-center'>
                                                <p className='mb-0'>No communication found</p>
                                            </div>
                                        )
                                    }
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
            {confirmationStatus && (
                <ConfirmationModal show={confirmationStatus} handleClose={() => setConfirmationStatus(null)} handleSubmit={() => handleStatusChange(confirmationStatus)} text={'Sure, you want to close this inquiry ?'} submitButtonText="Yes" closeButtonText="No" />
            )}
        </React.Fragment>
    )
}

export default EditQuery